import { render } from "./OauthButton.vue?vue&type=template&id=313d8fa0&scoped=true"
import script from "./OauthButton.vue?vue&type=script&lang=js"
export * from "./OauthButton.vue?vue&type=script&lang=js"

import "./OauthButton.vue?vue&type=style&index=0&id=313d8fa0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313d8fa0"]])

export default __exports__